// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"fa4a09ae","453":"670e15c7"}[chunkId] + ".chunk.js";
};